export class Booking {
  sourceLocation: string;
  bookingStartDateTime: string;
  bookingEndDateTime: string;
  bookingStatus: string;
  adminRemarks: string;
  bookingType: string;
  translatedBookingType : string;
}

export class Vehicle {
  licenceTag: string;
  vehicleOwner: string;
  sharedVehicleGroup: string;
  organizationName: string;
  type: string;
  vehicleClass: string;
  bodyStyle: string;
  // airco: boolean;
  // towbar: boolean;
  fuelType: string;
  brand: string;
  color: string;
  pricingCategory: string;
  attributeList: string[];
}

export class Driver {
  licenceNumber: string;
  driverName: string;
  email: string;
}

export class BookingOverview {
  booking: Booking;
  reccuringBooking: Booking[];
  vehicle: Vehicle;
  driver: Driver;
  isspecialPeriod: boolean;
  bookingDuration: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/booking-overview.model.ts